import React from "react";
import TileStep from "../shared/TileStep";
import { ReactComponent as LinkVector } from "../../assets/link-over-ui.svg";
import { Info } from "lucide-react";
import LeftSideBar from "../shared/LeftSideBar";
import LeftSideBarSpacing from "../shared/LeftSideBarSpacing";
import LiveWaitingIndicator from "../shared/LiveWaitingIndicator";
import { DOCS_LINKING_FLOW_GET_STARTED_PATH } from "../../../../../router/RouterUtils";
import useDashboardOnboardingStatus from "../../hooks/useDashboardOnboardingStatus";
import { ReactComponent as Mountain } from "../../assets/mountain-image.svg";
import { Link, Tooltip, Text } from "@merge-api/merge-javascript-shared";
import MagicLinkInfoCard from "./MagicLinkInfoCard";

const AddLinkToAppSection = () => {
  const dashboardOnboardingStatus = useDashboardOnboardingStatus();

  return (
    <div className="flex flex-col mx-auto">
      <div className="flex flex-row items-start">
        <div className="flex flex-col">
          <Text variant="h3" className="mb-6">
            Add Merge Link to your product
          </Text>
          <div className="flex flex-row">
            <LeftSideBar stepNumber="1" isNormalStep />
            <TileStep
              img={<LinkVector />}
              title={
                <div className="flex items-center flex-row gap-2">
                  Installation
                  <Tooltip
                    title="In order to successfully complete this step, you must pass your
                        production access key in as a header to get a link token."
                  >
                    <span className="flex items-center">
                      <Info size={16} className="text-gray-40" />
                    </span>
                  </Tooltip>
                </div>
              }
              subtitle={
                <>
                  Add Merge Link to your product using{" "}
                  <Link target="_blank" href={DOCS_LINKING_FLOW_GET_STARTED_PATH}>
                    this guide
                  </Link>{" "}
                  in our docs.
                </>
              }
              stepNumber={1}
            />
          </div>
          <div className="flex flex-row">
            <LeftSideBarSpacing />
            <div className="px-0 h-8" />
          </div>
          <div className="flex flex-row">
            <LeftSideBar stepNumber="2" isNormalStep={false} />
            <TileStep
              img={
                <div className="relative flex justify-center items-center top-[5px]">
                  <div className="absolute">
                    <Mountain className="h-[100px]" />
                  </div>
                  <div className="absolute bottom-5">
                    <LiveWaitingIndicator
                      color={
                        dashboardOnboardingStatus?.has_opened_production_link ? "green" : "red"
                      }
                    />
                  </div>
                </div>
              }
              title="Test run"
              subtitle={
                <>
                  <p>
                    Once you've added Merge Link to your product, visit your domain and open it.
                  </p>
                  Merge Link will give us the 👍 and we'll check this one off your list!
                </>
              }
              stepNumber={2}
            />
          </div>
          <div className="flex 2xl:hidden w-full mb-8 mt-8">
            <MagicLinkInfoCard />
          </div>
        </div>
        <div className="px-0 hidden 2xl:block">
          <div className="h-8 mb-[17px]" />
          <div className="w-[240px] mt-[10px] ml-8">
            <MagicLinkInfoCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLinkToAppSection;
